






























import Component from 'vue-class-component'
import Page from '~pages/ressort/_category/page/_page.vue'
import RessortTitle from '~components/content/widgets/listings/RessortTitle.vue'

import { ListingPageVariables } from '~base/mixins/listings'
import { ApolloOperationVariables } from '~base/common/types'

@Component<Page & VorteilsclubPage>({
  components: {
    RessortTitle,
  },
  apollo: {
    search: {
      query: require('~base/graphql/queries/FetchPostsForCategory.gql'),
      variables(): ListingPageVariables {
        return this.variables
      },
      prefetch({ route }: any): ListingPageVariables {
        return {
          first: this.perPage,
          page: parseInt(route.params.page || '0'),
          categories: [this.chosenCategory],
        }
      },
      result({ data }) {
        this.gotResult(data)
      },
    },
    categories: {
      query: require('~base/graphql/queries/FetchCategory.gql'),
      prefetch(): ApolloOperationVariables {
        return {
          slug: [this.chosenCategory],
        }
      },
      variables(): ApolloOperationVariables {
        return {
          slug: [this.chosenCategory],
        }
      },
    },
  },
})
export default class VorteilsclubPage extends Page {
  protected chosenCategory: string = `vorteilsclub`
  protected settingsKey = 'vorteilsclub'

  get variables(): ListingPageVariables {
    return {
      first: this.perPage,
      page: parseInt(this.$route.params.page || '0'),
      categories: [this.chosenCategory],
    }
  }

  onTitleAction(e: string) {
    this.chosenCategory = e
    this.after = ''
    this.fetched = []
  }

  get linkPrefix(): string {
    return `/ressort/vorteilsclub`
  }

  loadMoreData() {
    const { endCursor } = this.search.pageInfo
    if (endCursor) {
      this.after = endCursor
      this.nextPage()
    }
  }
}
